import React from 'react';
import FacebookLoginButton from "../../UI/FacebookLoginButton";
import './NotSigned.scss'
import {useAbility} from "@casl/react";
import {AbilityContext} from "../../../utils/app";
import {faThumbsUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faShieldCheck} from "@awesome.me/kit-a13c95776b/icons/modules/sharp/solid";

const NotSigned  = (props) => {
    const ability = useAbility(AbilityContext);

    return (
        <div className="col-lg-7">

            <h4 className="mb-4">
                Welcome to CommentGuard 👋
            </h4>

            <div className="connect-page-msg message my-4">
                Login with Facebook to connect your account.
            </div>

            <div className="connect-page-msg message my-4">
                Once your account is connected, you will be redirected back to CommentGuard to add the Facebook Pages or
                Instagram Business Accounts you'd like to be moderated.
            </div>
            {ability.can("create", "PagesController") && <FacebookLoginButton href="/auth/facebook" text="Login with Facebook"/>}

            <div className="message mt-4 mb-2">
                <FontAwesomeIcon icon={faShieldCheck} className="fa-fw s-icon"/>
                Approved by Meta to request all required permissions.
            </div>
            <div className="message my-2">
                <FontAwesomeIcon icon={faShieldCheck} className="fa-fw s-icon"/>
                Trusted to protect {props.total_pages_count}+ Facebook pages and Instagram accounts.
            </div>
            <div className="message my-2">
                <FontAwesomeIcon icon={faShieldCheck} className="fa-fw s-icon"/>
                Details are encrypted and stored securely, remove the connection at any time.
            </div>

        </div>
    )
}

export default NotSigned;